<template>
  <fragment v-if="active">
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('messages.addVolumeWarning')"
      :confirm="confirmation.onConfirm"
      v-model="confirmation.visible"
    />
    <ValidationObserver ref="airlineObserver" v-slot="{ validate, invalid }">
      <form
        autocomplete="off"
        @submit.prevent="validate().then(createOffer(invalid, values))"
      >
        <v-row class="my-4">
          <v-col
            cols="12"
            v-if="
              ($store.state.Type === 'Customer' ||
                $store.state.Type === 'PendingCustomer') &&
              demand &&
              showDemandOptions
            "
            style="
              background-color: var(--demandBackground);
              padding: 30px;
              margin-bottom: 3%;
            "
          >
            <v-row>
              <FormElement
                v-for="(element, index) in form_demand_customer"
                :key="
                  'SUPPLIER_' +
                  element.key.parent +
                  '_' +
                  element.key.child +
                  '_' +
                  index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="true"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
              />
              <v-col style="margin-top: 10%">
                <v-btn
                  style="
                    padding: 22px 40px !important;
                    border-radius: 12px !important;
                  "
                  elevation="0"
                  class="button flexible-button volumeButton"
                  dark
                  type="button"
                  @click="demandPrice(validate, invalid)"
                  :loading="$store.state.loadingStatus"
                >
                  {{
                    $t(
                      'buttons.' +
                        ($store.state.Type === 'Customer' ||
                        $store.state.Type === 'PendingCustomer'
                          ? targetPrice != null
                            ? 'updateOffer'
                            : 'demandPrice'
                          : 'giveCustomerAPrice')
                    )
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <FormElement
            v-for="(element, index) in form_types"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :disabled="demand"
            :placeholder="$t(element.placeholder)"
          />
          <v-col cols="12">
            <v-row>
              <FormElement
                v-for="(element, index) in form_expressTypes"
                :key="
                  element.key.parent + '_' + element.key.child + '_' + index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="true"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="demand"
                :placeholder="$t(element.placeholder)"
                :willBeEliminated="false"
              />
            </v-row>
          </v-col>
          <FormElement
            v-for="(element, index) in form_destination"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :disabled="demand"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :placeholder="$t(element.placeholder)"
            :willBeEliminated="element.willBeEliminated"
          />
          <FormElement
            v-for="(element, index) in form_details"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :disabled="demand || element.disabled"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :placeholder="$t(element.placeholder)"
          />
          <FormElement
            v-for="(element, index) in form_container_details"
            :key="
              'CONTAINER_DETAILS_' +
              element.key.parent +
              '_' +
              element.key.child +
              '_' +
              index
            "
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :disabled="demand || element.disabled"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :placeholder="$t(element.placeholder)"
          />
          <v-col
            v-if="
              transferType != 2 &&
              (!demand || (demand && item.volumes?.length > 0)) &&
              item.expressPackageType !== 2
            "
            lg="3"
            class="form-column d-flex justify-lg-center justify-xl-start"
            style="padding: 0; min-height: 86px"
          >
            <v-btn
              style="
                color: #fff;
                text-transform: unset !important;
                background-color: var(--primary);
                height: 65%;
                width: 100%;
                border-radius: 20px !important;
                font-weight: bold;
                font-size: small;
              "
              elevation="0"
              class="volumeButton"
              @click="addVolumeModal = true"
            >
              <p class="addPackageLabel mt-4">
                <v-icon>mdi-plus</v-icon>
                {{
                  $t(
                    'buttons.' + (demand ? 'viewPackageDetails' : 'addPackage')
                  ) +
                  '(' +
                  item.volumes?.length +
                  ')'
                }}
              </p>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="12">
            <AddVolume
              :onSave="onSaveVolumes"
              :key="`AIRLINE_ADD_VOLUME_${convertedVolumes?.length}`"
              :volumesByUser="convertedVolumes"
              v-if="
                ((transferType === 2 &&
                  demand &&
                  convertedVolumes?.length > 0) ||
                  (!demand && convertedVolumes?.length) ||
                  !body.fastShippingSearchId ||
                  (body.fastShippingSearchId && !demand)) &&
                !$store.state.loadingStatus &&
                !editing
              "
              :fast-shipping-search-id="body.fastShippingSearchId"
              :container-types="containerTypes"
              v-model="addVolumeModal"
              :read-only="demand || item.expressPackageType === 2"
              :isCard="transferType === 2"
              :calculateParameter="calculateParameter"
              :calculateChargeableWeight="
                transferType === 2 ? $calculateChargeableWeight : null
              "
              :isFirstSearch="isFirstSearch"
              :oneTimeSave="body?.isIntegration"
            />
          </v-col>
          <v-col v-if="transferType == 2" cols="9"></v-col>
          <FormElement
            v-for="(element, index) in form_other"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="false"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :disabled="demand"
            :placeholder="$t(element.placeholder)"
            v-if="item.selectedService"
          />
          <v-col
            cols="12"
            v-if="
              !showDemandOptions &&
              ($store.state.Type === 'Customer' ||
                $store.state.Type === 'PendingCustomer')
            "
          >
            <p style="color: white">
              <span style="font-weight: bold">{{ $t('labels.note') }}:</span>
              <span> {{ $t('titles.theOffer') }} </span>
              <span style="font-weight: bold; text-decoration: underline">
                {{
                  !item.isTransshipment
                    ? $t('messages.noTransshipment')
                    : $t('messages.withTransshipment', {
                        value: item.transshipmentCount,
                      })
                }}
              </span>
            </p>
          </v-col>

          <v-col
            v-if="!demand && item.selectedService"
            cols="12"
            sm="12"
            md="4"
            style="padding: 0"
            class="ml-auto d-flex flex-column justify-end"
          >
<v-btn
  elevation="0"
  type="submit"
  :loading="creatingOffer"
  class="volumeButton custom-offer-btn"
>
  {{ $t('buttons.getAnOffer') }}
</v-btn>
          </v-col>
          <v-col
            cols="12"
            v-else-if="
              ($store.state.Type === 'Supplier' ||
                $store.state.Type === 'PendingSupplier') &&
              showDemandOptions
            "
            style="
              background-color: var(--demandBackground);
              padding: 30px;
              margin-top: 3%;
            "
          >
            <v-row>
              <v-col lg="12" sm="12" class="mb-6">
                <span
                  style="
                    font-weight: bold;
                    color: white;
                    text-decoration: underline;
                  "
                  v-if="item.searchPrice"
                  >{{
                    $t('messages.listedAlready', { price: item.searchPrice })
                  }}</span
                >
              </v-col>
              <FormElement
                v-for="(element, index) in form_demand_supplier"
                :key="
                  'SUPPLIER_' +
                  element.key.parent +
                  '_' +
                  element.key.child +
                  '_' +
                  index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="true"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
              />

              <v-col cols="12" lg="12" class="mb-4">
                <v-row>
                  <FormElement
                    :key="'SUPPLIER_IS_TRANSHIPMENT'"
                    :vertical="true"
                    v-model="item.isTransshipment"
                    :validationLabel="$t('labels.isTransshipment')"
                    :labelShown="false"
                    :topLabel="true"
                    :formType="{
                      name: 'checkbox',
                    }"
                    :lg="3"
                    :cols="6"
                    :light="true"
                    :placeholder="$t('labels.isTransshipment')"
                  />

                  <FormElement
                    :key="'SUPPLIER_TRANSHIPMENT_COUNT'"
                    :vertical="true"
                    v-model="item.transshipmentCount"
                    :validationLabel="$t('labels.transshipmentCount')"
                    :formLabel="$t('labels.transshipmentCount')"
                    :formType="{
                      name: 'text',
                    }"
                    rules="required|numeric|min_value:1"
                    :lg="6"
                    :labelShown="false"
                    :topLabel="true"
                    :cols="12"
                    :light="true"
                    :defaultValue="1"
                    :active="!!item.isTransshipment"
                    :placeholder="$t('labels.transshipmentCount')"
                  />
                </v-row>
              </v-col>

              <FormElement
                :key="'SUPPLIER_item_note_102321'"
                :vertical="true"
                v-model="item.supplierNote"
                :validationLabel="$t('labels.note')"
                :rules="''"
                :formLabel="$t('labels.note')"
                :formType="{
                  name: 'textarea',
                }"
                :lg="8"
                :cols="6"
                :light="true"
                :labelShown="false"
                :topLabel="true"
                :placeholder="$t('labels.note')"
              />
              <v-col lg="4" col="12">
                <v-row>
                  <FormElement
                    :key="'EXPIRY_DATE_AIRLINE'"
                    :vertical="true"
                    v-model="item.expiryDate"
                    :validationLabel="$t('labels.expiryDate')"
                    :formLabel="$t('labels.expiryDate')"
                    :formType="{
                      name: 'date',
                      dateMode: 'date',
                    }"
                    :lg="12"
                    :cols="12"
                    :light="true"
                    :labelShown="false"
                    :topLabel="true"
                    :placeholder="$t('labels.expiryDate')"
                  />
                  <v-col cols="12" lg="12">
                    <v-btn
                      style="
                        padding: 22px 40px !important;
                        border-radius: 12px !important;
                      "
                      elevation="0"
                      class="button flexible-button volumeButton"
                      dark
                      type="button"
                      @click="demandPrice(validate, invalid)"
                      :loading="$store.state.loadingStatus"
                    >
                      {{
                        $t(
                          'buttons.' +
                            ($store.state.Type === 'Customer' ||
                            $store.state.Type === 'PendingCustomer'
                              ? 'demandPrice'
                              : price != 0
                              ? 'updateOffer'
                              : 'giveCustomerAPrice')
                        )
                      }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="my-4 d-flex align-center justify-center">
          <v-icon class="mr-4" large color="red">mdi-alert</v-icon>
          <ul>
            <li class="my-0 mx-auto" style="font-size: small; color: var(--darkRed)">
              {{ $t('messages.expressWarning') }}
            </li>
            <li class="my-0 mx-auto " style="font-size: small; color: var(--darkRed)">
              {{ $t('messages.expressPolicyWarning') }}
            </li>
          </ul>
        </div>
      </form>
    </ValidationObserver>
  </fragment>
</template>
<script>
import FormElement from '../../components/FormElement.vue';
import ConfirmationModal from '../../components/General/ConfirmationModal.vue';
import OfferServices from '../../services/OfferServices';
import SpotShippingServices from '../../services/SpotShippingServices';
import {
  getCountries,
  getCities,
  getAirports,
  getCurrencyTypes,
  getHazmatCodes,
  getEquipmentTypes,
  removeNullValues,
  convertVolumeToBoxes,
  convertBoxesToVolumes,
  convertToNumber,
  logisticsTypes,
} from '../../utils/constants';
import AddVolume from './AddVolume.vue';
import LocationService from '../../services/LocationService';

import PortalService from '../../services/PortalService';
import { roundWeight } from '../../utils/common';
import { getPostalCodeRules } from '../../utils/validationRules';
import { getSpecialRulesForPostalCode } from '../../utils/common';

export default {
  constructor: () => {},
  name: 'Airline',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    add: {
      type: Boolean,
      default: false,
    },
    demandOnFinally: {
      type: Function,
      default: () => {},
    },
    transferType: {
      type: Number,
      default: 1,
    },
    createOffer: {
      type: Function,
      default: () => {},
    },
    creatingOffer: {
      type: Boolean,
      default: false,
    },
    body: {
      type: Object,
      default: () => null,
    },
    demand: {
      type: Boolean,
      default: false,
    },
    showDemandOptions: {
      type: Boolean,
      default: true,
    },
    isFirstSearch: {
      type: Boolean,
      default: false,
    },
  },
  components: { FormElement, AddVolume, ConfirmationModal },
  mounted() {
    this.setup();
  },
  data() {
    return {
      // List
      getDangerousMaterialLevels: [],
      countries: [],
      currencies: [],
      cities_fromWhere: [],
      cities_toWhere: [],
      airports: [],
      containerTypes: [],

      // Data
      item: {
        volumes: [],
      },

      // States
      shipmentType: 1,
      pageLoading: false,
      addVolumeModal: false,
      dateMenu: false,

      confirmation: {
        onConfirm: () => {},
        visible: false,
      },
      price: 0,
      targetPrice: 0,
      calculateParameter: 166.67,

      editing: false,

      integrationServices: [],

      isUpdating: false,
    };
  },
  watch: {
    shipmentType() {
      this.resetForm();
    },

    'item.volume': function (newValue) {
      if (this.item.volumes?.length > 0) return;

      const totalVolume = newValue || 0,
        totalWeight = parseFloat(this.item.kilo) || 0;

      const calculatedVolumeWeight = this.$getFormattedFloatValue(
        totalVolume * this.calculateParameter
      );
      this.item.chargeableWeight = roundWeight(
        totalWeight > calculatedVolumeWeight
          ? totalWeight
          : calculatedVolumeWeight
      );
    },
    'item.kilo': function (newValue) {
      if (this.item.volumes?.length > 0) return;

      const totalVolume = this.item.volume || 0,
        totalWeight = parseFloat(this.item.kilo) || 0;

      const calculatedVolumeWeight = this.$getFormattedFloatValue(
        totalVolume * this.calculateParameter
      );
      this.item.chargeableWeight = roundWeight(
        totalWeight > calculatedVolumeWeight
          ? totalWeight
          : calculatedVolumeWeight
      );
    },
    transferType() {
      this.resetForm();
    },
  },
  methods: {
    /**
     * Triggers when portal type is changed.
     * After trigger two new fields are added respectively to the selected portal type
     */
    async portalTypeChanged() {
      if (this.item.subsupplier) {
        this.$store.state.loadingStatus = true;
        PortalService.getIntegrationServices(this.item.subsupplier)
          .then((response) => {
            this.integrationServices = response.data.Result;
          })
          .catch(window.showError)
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
    demandPrice(validate, invalid = false) {
      validate();
      if (!invalid) {
        this.$store.state.loadingStatus = true;
        if (
          this.$store.state.Type === 'Customer' ||
          this.$store.state.Type === 'PendingCustomer'
        ) {
          let request = null;
          if (this.add) {
            request = SpotShippingServices.addSpotShipping(
              this.item.fastShippingSearchId,
              convertToNumber(this.item.targetPrice),
              this.item.targetPriceCurrency,
              this.item.customerNote
            );
          } else if (this.item.spotShippingId) {
            request = SpotShippingServices.updateSpotShipping(
              this.item.spotShippingId,
              convertToNumber(this.item.targetPrice),
              this.item.targetPriceCurrency,
              this.item.customerNote
            );
          }
          try {
            request
              .then((response) => {
                window.showSuccess(this.$t('messages.demandPriceSuccessfull'));
                if (this.demandOnFinally) {
                  this.demandOnFinally();
                }
              })
              .catch(window.showError)
              .finally(() => {
                this.$store.state.loadingStatus = false;
              });
          } catch (error) {
            window.showError(error);
            this.$store.state.loadingStatus = false;
          }
        } else {
          OfferServices.updateSupplierPriceOffer({
            Id: this.item.id,
            Price: convertToNumber(this.item.price),
            CurrencyTypeId: this.item.priceCurrency,
            ExpiryDate: this.item.expiryDate,
            TransitTime: this.item.transferTime,
            Note: this.item.supplierNote,
            IsTransshipment: this.item.isTransshipment,
            TransshipmentCount: this.item.isTransshipment
              ? this.item.transshipmentCount
              : 1,
            SubSupplier: this.item.subsupplier,
            SubSupplierService: this.item.subsupplierServiceType,
          })
            .then((response) => {
              window.showSuccess(this.$t('messages.demandPriceSuccessfull'));

              if (this.demandOnFinally) {
                this.demandOnFinally();
              }
            })
            .catch(window.showError)
            .finally(() => {
              this.$store.state.loadingStatus = false;
            });
        }
      }
    },
    async setup() {
      /* Data Checking */
      if (this.body.citiesFrom) {
        this.cities_fromWhere = this.body.citiesFrom;
      }
      if (this.body.citiesTo) {
        this.cities_toWhere = this.body.citiesTo;
      }
      if (this.body.countries) {
        this.countries = this.body.countries;
      }
      if (this.body.airports?.length) {
        this.airports = this.body.airports;
      }
      if (this.body.hazmatCodes) {
        this.getDangerousMaterialLevels = this.body.hazmatCodes;
      }
      if (this.body.currencyTypes) {
        this.currencies = this.body.currencyTypes;
      }
      if (this.body.equipmentTypes) {
        this.containerTypes = this.body.equipmentTypes;
      }
      /* Data Checking END */

      this.getDangerousMaterialLevels?.length == 0
        ? (this.getDangerousMaterialLevels = await getHazmatCodes())
        : null;

      if (this.currencies?.length === 0) {
        this.currencies = await getCurrencyTypes();
      }

      if (this.body?.item) {
        this.item = { ...this.item, ...this.body.item };
        this.price = this.body.item.price;
        this.targetPrice = this.body.item.targetPrice;
        if (
          this.item.country_fromWhere &&
          this.cities_fromWhere?.length === 0
        ) {
          this.cities_fromWhere = await getCities(this.item.country_fromWhere);
        }
        if (this.item.country_toWhere && this.cities_toWhere?.length === 0) {
          this.cities_toWhere = await getCities(this.item.country_toWhere);
        }

        if (this.item.subsupplier) {
          await this.portalTypeChanged();
        }
      }

      if (!this.airports.length && this.transferType !== 2) {
        this.airports = (await getAirports()) || [];
      }

      this.updatePlaces('all');
    },

    /**
     * Change Places According To Selections
     */
    async updatePlaces(parameter = 'places') {
      if (!this.isUpdating) {
        this.isUpdating = true;

        if (parameter === 'places' || parameter === 'all') {
          if (
            this.airports?.length === 0 &&
            !!this.item.selectedService &&
            this.transferType !== 2
          ) {
            getAirports().then((response) => {
              this.airports = response;
            });
          }
          switch (this.item.selectedService) {
            case 1:
              this.countries?.length === 0
                ? (this.countries = await getCountries())
                : null;
              break;
          }
        }

        if (parameter === 'equipments' || parameter === 'all') {
          if (
            this.body?.equipmentTypes?.length === 0 &&
            this.containerTypes?.length === 0
          ) {
            this.containerTypes = await getEquipmentTypes({
              TransportationType: 0,
            });
          }
        }

        this.isUpdating = false;
      }
    },

    /**
     * If user saves the volumes then this will be triggered.
     */
    onSaveVolumes(volumes, parameters) {
      const {
        totalContainerCount,
        totalVolume,
        totalKilo,
        totalInvoiceWeight,
        chargeableWeight,
      } = parameters;

      const updateVolumes = () => {
        this.item.volumes = volumes;
        this.item.doorCount = totalContainerCount;
        this.item.kilo = totalKilo;
        this.item.volume = totalVolume;

        this.item.chargeableWeight = chargeableWeight;

        this.item = Object.assign({}, this.item);

        console.log('Update Volumes', volumes);
      };

      this.confirmation.onConfirm = () => {
        if (this.body?.fastShippingSearchId && !this.body?.isIntegration) {
          const converted = convertVolumeToBoxes(volumes);

          this.$store.state.loadingStatus = true;
          this.editing = true;
          SpotShippingServices.updateBoxes({
            FastShippingSearchId: this.body.fastShippingSearchId,
            boxViewModels: converted,
            ChargeableWeight: parseFloat(chargeableWeight),
          })
            .then((response) => {
              updateVolumes();
              window.showSuccess(this.$t('messages.updateBoxesSuccessfully'));
            })
            .catch(window.showError)
            .finally(() => {
              this.$store.state.loadingStatus = false;
              this.editing = false;
            });
        } else {
          updateVolumes();
        }
      };

      if (
        (parseInt(this.item.doorCount) !== totalContainerCount ||
          parseFloat(this.item.kilo).toFixed(2) !== totalKilo ||
          parseFloat(this.item.volume).toFixed(2) !== totalVolume) &&
        this.item.doorCount &&
        this.item.kilo &&
        this.item.volume &&
        this.transferType !== 2
      ) {
        this.confirmation.visible = true;
        console.log('Giriş 1');
        return;
      } else {
        this.confirmation.onConfirm();
        console.log('Giriş 2');
        return;
      }
    },

    /**
     * Resetting forms' validation.
     */
    async resetForm() {
      this.item = {};
      this.item.volumes = [];
      this.$refs.airlineObserver.reset();
      this.setup();
    },
    async quickAddCity(cityName, type = 'fromWhere') {
      this.$store.state.loadingStatus = true;
      const countryId =
        type === 'fromWhere'
          ? this.item.country_fromWhere
          : this.item.country_toWhere;
      const body = { CountryId: countryId, Name: cityName };
      try {
        const response = await LocationService.addCityForCustomer(body);
        const data = response?.data?.Result;
        if (data) {
          const newCity = { Id: data?.Id, Name: cityName };
          if (type === 'fromWhere') {
            this.cities_fromWhere.push(newCity);
            this.item.city_fromWhere = newCity.Id;
          } else {
            this.cities_toWhere.push(newCity);
            this.item.city_toWhere = newCity.Id;
          }
          window.showSuccess(
            this.$t('messages.addCitySuccess') ||
              'Şehir başarılı bir şekilde eklendi.'
          );
        }
      } catch (err) {
        window.showError(err);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
    getExtraPostalCodeRules(list, country) {
      return getSpecialRulesForPostalCode(list, country);
    },
  },
  computed: {
    convertedVolumes() {
      if (this.item.volumes?.length > 0 && this.demand) {
        if (this.item.volumes[0].Id) {
          return convertBoxesToVolumes(
            this.item.volumes,
            this.body.shipmentType
          );
        }
      }
      return this.item.volumes;
    },
    taxPayers() {
      const allowedTaxes = this.$store.getters.getAllowedOrderTax || [0, 1];
      return [
        {
          name: this.$t('labels.dap'),
          value: 0,
          IsExceedsLimits: !allowedTaxes.includes(0),
        },
        {
          name: this.$t('labels.ddp'),
          value: 1,
          IsExceedsLimits: !allowedTaxes.includes(1),
        },
      ];
    },
    values() {
      return removeNullValues(this.item);
    },
    serviceTypes() {
      let serviceTypes = [];
      if (this.transferType !== 2) {
        serviceTypes.push({
          Id: 3,
          Name: this.$t('labels.portToPort'),
        });
      }

      serviceTypes.push({
        Id: 1,
        Name: this.$t('labels.doorToDoor'),
      });

      // if (this.transferType == 2 && this.body.exportImportType == 0) {
      //   serviceTypes.push({
      //     Id: 5,
      //     Name: this.$t('labels.doorToPort'),
      //   });
      // }

      return serviceTypes;
    },
    form_types() {
      return [
        {
          key: {
            parent: 'item',
            child: 'loadType',
          },
          hidden: this.transferType == 2,
          active: this.transferType != 2,
          rules: 'required',
          validationLabel: 'labels.loadType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.$root.loadTypeFor.airline,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-earth',
          },
          onChange: () => {
            this.updatePlaces('equipments');

            if (this.item.selectedService) {
              this.item.selectedService = -1;
            }
          },
          lg: 4,
          placeholder: 'labels.loadType',
        },
        {
          key: {
            parent: 'item',
            child: 'selectedService',
          },
          rules: 'required',
          validationLabel: 'labels.serviceType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.serviceTypes,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-airplane-cog',
          },
          onChange: () => {
            this.item = {
              ...this.item,
              selectedService: this.item.selectedService,
              loadType: this.item.loadType,
            };
          },
          lg: 6,
          placeholder: 'labels.serviceType',
        },
        {
          key: {
            parent: 'item',
            child: 'taxPayer',
          },
          rules: 'required',
          validationLabel: 'labels.taxPayer',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.taxPayers,
              value: 'value',
              text: 'name',
            },
            prepend: 'mdi-currency-usd',
          },
          onChange: () => {
            this.updatePlaces();

            this.item = {
              ...this.item,
              selectedService: this.item.selectedService,
              loadType: this.item.loadType,
              taxPayer: this.item.taxPayer,
            };
          },
          lg: 6,
          placeholder: 'labels.taxPayer',
          active: this.transferType === 2,
        },
      ];
    },

    form_expressTypes() {
      return [
        {
          key: {
            parent: 'item',
            child: 'expressPackageType',
          },
          rules: 'required',
          validationLabel: 'labels.expressPackageType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.$expressPackageTypes,
              value: 'value',
              text: 'name',
            },
            prepend: 'mdi-plus',
          },
          lg: 6,
          placeholder: 'labels.expressPackageType',
          active: this.transferType == 2,
          onChange: () => {
            if (this.item.expressPackageType === 2) {
              this.item.expressServiceType = 5;
              this.onSaveVolumes(
                [
                  {
                    volume: '0.00',
                    volumeWeight: 0,
                    kilo: '0.40',
                    height: '1',
                    length: '1',
                    width: '1',
                    countInCap: '1',
                    packageType: 'Envelope',
                    productType: 'Envelope',
                    containerCount: '1',
                    index: 0,
                    totalWeight: '0.40',
                  },
                ],
                {
                  canStack: true,
                  totalContainerCount: 1,
                  totalKilo: '0.400',
                  totalVolume: '0.000',
                  totalVolumeWeight: 0.4,
                  willNotBeStacked: false,
                  chargeableWeight: '0.40',
                }
              );
            } else {
              this.item.volumes = [];
              this.item.doorCount = 0;
              this.item.kilo = 0;
              this.item.chargeableWeight = 0;
              this.item.volume = 0;
            }
          },
        },
        {
          key: {
            parent: 'item',
            child: 'expressServiceType',
          },
          rules: 'required',
          validationLabel: 'titles.expressServiceType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.$expressServiceTypes,
              value: 'value',
              text: 'name',
            },
            prepend: 'mdi-plus',
          },
          lg: 6,
          placeholder: 'titles.expressServiceType',
          active: this.item.expressPackageType !== 2 && this.transferType == 2,
        },
      ];
    },
    form_destination() {
      return [
        {
          key: {
            parent: 'item',
            child: 'airport_fromWhere',
          },
          rules: this.item.selectedService === 3 ? 'required' : '',
          validationLabel: 'labels.fromAirport',
          topLabel: true,
          labelShown: false,
          hidden: this.transferType == 2,
          active: !!this.item.selectedService && this.transferType != 2,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.airports,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-airplane-takeoff',
          },

          lg:
            this.transferType == 2 && this.item.selectedService === 5
              ? 6
              : this.transferType == 2
              ? 4
              : 6,
          placeholder: 'labels.fromAirport',
        },
        {
          key: {
            parent: 'item',
            child: 'airport_toWhere',
          },
          rules: this.item.selectedService === 3 ? 'required' : '',
          validationLabel: 'labels.toAirport',
          topLabel: true,
          hidden: this.transferType == 2,
          active: !!this.item.selectedService && this.transferType != 2,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.airports,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-airplane-landing',
          },
          lg: 6,
          placeholder: 'labels.toAirport',
        },
        {
          key: {
            parent: 'item',
            child: 'country_fromWhere',
          },
          rules: 'required',
          validationLabel: 'labels.fromWhere',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.countries,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-flag-variant',
          },
          onChange: async () => {
            if (this.item.country_fromWhere)
              this.cities_fromWhere = await getCities(
                this.item.country_fromWhere
              );
          },
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          lg: 6,
          cols: 12,
          placeholder: 'labels.fromWhere',
        },
        {
          key: {
            parent: 'item',
            child: 'city_fromWhere',
          },
          rules: this.isFirstSearch || this.transferType == 2 ? '' : 'required',
          validationLabel: 'labels.fromWhereCity',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.cities_fromWhere,
              value: 'Id',
              text: 'Name',
              onAddNewItem:
                (this.$store.state.Type === 'Customer' ||
                  this.$store.state.Type === 'PendingCustomer') &&
                this.item.country_fromWhere
                  ? (cityName) => this.quickAddCity(cityName, 'fromWhere')
                  : null,
            },
            prepend: 'mdi-flag-variant',
          },
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          cols: 12,
          sm: 6,
          md: 6,
          xl: 4,
          lg: 4,
          placeholder: 'labels.city',
        },
        {
          key: {
            parent: 'item',
            child: 'postalCode_fromWhere',
          },
          required: !this.isFirstSearch,
          rules:
            this.transferType === 2
              ? ''
              : getPostalCodeRules(
                  this.getExtraPostalCodeRules(
                    this.countries,
                    this.item.country_fromWhere
                  )
                ),
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          validationLabel: 'labels.postalCode_from',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-mailbox-open-outline',
          },
          cols: 12,
          sm: 6,
          md: 6,
          xl: 2,
          lg: 2,
          placeholder: 'labels.postalCode',
        },
        {
          key: {
            parent: 'item',
            child: 'country_toWhere',
          },
          rules: 'required',
          validationLabel: 'labels.toWhere',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.countries,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-flag-variant',
          },
          onChange: async () => {
            if (this.item.country_toWhere)
              this.cities_toWhere = await getCities(this.item.country_toWhere);

            if (this.item.selectedService === 5) {
              console.log('airports');
              this.airports = [];
              this.airports = await getAirports(
                '',
                this.item.country_toWhere,
                this.item.cities_toWhere,
                1,
                9999
              );
            }
          },
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          lg: 6,
          cols: 12,
          placeholder: 'labels.toWhere',
        },
        {
          key: {
            parent: 'item',
            child: 'city_toWhere',
          },
          rules: this.isFirstSearch || this.transferType == 2 ? '' : 'required',
          validationLabel: 'labels.city',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.cities_toWhere,
              value: 'Id',
              text: 'Name',
              onAddNewItem:
                (this.$store.state.Type === 'Customer' ||
                  this.$store.state.Type === 'PendingCustomer') &&
                this.item.country_toWhere
                  ? (cityName) => this.quickAddCity(cityName, 'toWhere')
                  : null,
            },
            prepend: 'mdi-flag-variant',
          },
          onChange: async () => {
            this.airports = await getAirports(
              '',
              null,
              this.item.city_toWhere,
              1,
              9999
            );
          },
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          cols: 12,
          sm: 6,
          md: 6,
          xl: 4,
          lg: 4,
          placeholder: 'labels.city',
        },
        {
          key: {
            parent: 'item',
            child: 'postalCode_toWhere',
          },
          required: !this.isFirstSearch,
          rules:
            this.transferType === 2
              ? ''
              : getPostalCodeRules(
                  this.getExtraPostalCodeRules(
                    this.countries,
                    this.item.country_fromWhere
                  )
                ),
          validationLabel: 'labels.postalCode_to',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-mailbox-open-outline',
          },
          active:
            this.item.selectedService === 1 || this.item.selectedService === 5,
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          xl: 2,
          placeholder: 'labels.postalCode',
        },
      ];
    },
    form_details() {
      return [
        {
          key: {
            parent: 'item',
            child: 'airport_toWhere',
          },
          rules: this.item.selectedService === 3 ? 'required' : '',
          validationLabel: 'labels.toAirport',
          topLabel: true,
          hidden: !(
            this.transferType == 2 &&
            this.body.exportImportType == 0 &&
            this.item.selectedService == 5
          ),
          active:
            !!this.item.selectedService &&
            this.transferType == 2 &&
            this.body.exportImportType == 0 &&
            this.item.selectedService == 5,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.airports,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-airplane',
          },
          lg: 4,
          placeholder: 'labels.toAirport',
        },
      ];
    },
    form_container_details() {
      return [
        {
          key: {
            parent: 'item',
            child: 'doorCount',
          },
          rules: 'required|numeric|min_value:1',
          validationLabel: 'labels.doorCount',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-package-variant',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          disabled: this.demand || this.transferType == 2,
          placeholder: 'labels.doorCount',
        },
        {
          key: {
            parent: 'item',
            child: 'kilo',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.kilo',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-weight-kilogram',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          disabled: this.demand || this.transferType == 2,
          placeholder: 'labels.kilo',
        },
        {
          key: {
            parent: 'item',
            child: 'volume',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.volume',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-package',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          disabled: this.demand || this.transferType == 2,
          placeholder: 'labels.volume',
        },
        {
          key: {
            parent: 'item',
            child: 'chargeableWeight',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.chargeableWeight',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          disabled: true,
          placeholder: 'labels.chargeableWeight',
        },
      ];
    },
    form_container() {
      return [
        {
          key: {
            parent: 'item',
            child: 'containerType',
          },
          rules: 'required',
          validationLabel: 'labels.containerType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.containerTypes,
              value: 'Code',
              text: 'Code',
            },
          },
          lg: 3,
          cols: 12,
          placeholder: 'labels.containerType',
        },
        {
          key: {
            parent: 'item',
            child: 'containerCount',
          },
          rules: 'required|min_value:1',
          validationLabel: 'labels.containerCount',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 3,
          cols: 12,
          placeholder: 'labels.containerCount',
        },
      ];
    },
    form_other() {
      return [
        {
          key: {
            parent: 'item',
            child: 'isDangerousMaterial',
          },
          hidden: this.transferType == 2,
          active: this.transferType != 2,
          validationLabel: 'labels.isDangerousMaterial',
          formType: {
            name: 'checkbox',
          },
          lg: 3,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: 'labels.isDangerousMaterial',
        },
        {
          key: {
            parent: 'item',
            child: 'dangerousMaterialLevel',
          },
          rules: this.$data.item.isDangerousMaterial ? 'required' : '',
          validationLabel: 'labels.dangerousMaterialLevel',
          labelShown: false,
          hidden: this.transferType == 2,
          active: this.transferType != 2,
          topLabel: true,
          formType: {
            name: 'select',
            items: {
              data: this.getDangerousMaterialLevels,
              value: 'key',
              text: 'Value',
            },
          },
          lg: 9,
          active: !!this.$data.item.isDangerousMaterial,
          cols: 12,
          placeholder: 'labels.dangerousMaterialLevel',
        },
        {
          key: {
            parent: 'item',
            child: 'willNotBeStacked',
          },
          validationLabel: 'labels.myLoadWillNotBeStacked',
          formType: {
            name: 'checkbox',
          },
          labelShown: false,
          topLabel: true,
          hidden: this.transferType == 2,
          active: this.transferType != 2,
          cols: 12,
          sm: 12,
          md: 6,
          lg: 6,
          placeholder: 'labels.myLoadWillNotBeStacked',
        },
      ];
    },
    form_demand_supplier() {
      return [
        {
          key: {
            parent: 'item',
            child: 'targetPrice',
          },
          rules:
            this.$store.state.Type === 'Customer' ||
            this.$store.state.Type === 'PendingCustomer'
              ? 'numeric|min_value:1'
              : '',
          validationLabel: 'labels.targetPrice',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            backgroundColor: 'var(--disabledGray)',
          },
          lg: 3,
          cols: 3,
          disabled: true,
          placeholder: 'labels.targetPrice',
        },
        {
          key: {
            parent: 'item',
            child: 'price',
          },
          rules: 'required|numericWithDelimiters',
          validationLabel: 'labels.yourOffer',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            maskType: 'money',
          },
          lg: 3,
          cols: 3,
          placeholder: 'labels.yourOffer',
        },
        {
          key: {
            parent: 'item',
            child: 'priceCurrency',
          },
          rules: 'required',
          validationLabel: 'labels.yourOfferCurrency',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.currencies,
              value: 'Id',
              text: 'Code',
            },
          },
          lg: 3,
          cols: 3,
          placeholder: 'labels.yourOfferCurrency',
        },
        {
          key: {
            parent: 'item',
            child: 'transferTime',
          },
          rules: 'required|numeric|min_value:1',
          validationLabel: 'titles.transferTime',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 3,
          cols: 3,
          active: this.integrationServices?.length > 0,
          placeholder: 'titles.transferTime',
        },
        {
          key: {
            parent: 'item',
            child: 'subsupplier',
          },
          rules: 'required',
          validationLabel: 'titles.subsupplier',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: logisticsTypes,
              value: 'Value',
              text: 'Name',
            },
          },
          lg: 3,
          cols: 3,
          active: this.transferType === 2,
          placeholder: 'titles.subsupplier',
          onChange: this.portalTypeChanged,
        },
        {
          key: {
            parent: 'item',
            child: 'subsupplierServiceType',
          },
          rules: 'required',
          validationLabel: 'titles.integrationService',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.integrationServices,
              value: 'key',
              text: 'value',
            },
          },
          lg: 3,
          cols: 3,
          active: !!this.item.subsupplier,
          placeholder: 'titles.integrationService',
        },
      ];
    },
    form_demand_customer() {
      return [
        {
          key: {
            parent: 'item',
            child: 'targetPrice',
          },
          rules: 'numericWithDelimiters',
          validationLabel: 'labels.targetPrice',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            maskType: 'money',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.targetPrice',
        },
        {
          key: {
            parent: 'item',
            child: 'targetPriceCurrency',
          },
          rules: '',
          validationLabel: 'labels.currency',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.currencies,
              value: 'Id',
              text: 'Code',
            },
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.currency',
        },
        {
          key: {
            parent: 'item',
            child: 'customerNote',
          },
          validationLabel: 'labels.note',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'textarea',
          },
          lg: 8,
          cols: 6,
          placeholder: 'labels.note',
        },
      ];
    },
  },
};
</script>
<style></style>
